import { render, staticRenderFns } from "./StandartsListItems.vue?vue&type=template&id=2703ccaa&scoped=true&"
import script from "./StandartsListItems.vue?vue&type=script&lang=js&"
export * from "./StandartsListItems.vue?vue&type=script&lang=js&"
import style0 from "./StandartsListItems.vue?vue&type=style&index=0&id=2703ccaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703ccaa",
  null
  
)

export default component.exports